export class Attachment {
    content: any;
    selected: boolean;
}
